"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.JumpToDate = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _calendar = require("@kyruus/calendar");
var _messages = _interopRequireDefault(require("../../../../lib/messages"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MOMENT_FORMAT = _moment.default.localeData().longDateFormat('l');
const INPUT_ID = 'FilterJumpToDateCalendar';
const BaseJumpToDate = _ref => {
  let {
    date,
    dateInvalid,
    intl,
    onDateChange,
    setDateInvalid
  } = _ref;
  const [calendarFocused, setCalendarFocused] = (0, _react.useState)(null);
  const containerRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const input = window.document.getElementById(INPUT_ID);
    if (!input) return;
    // react-dates does not delineate between an invalid date and an empty one.
    // Empty should be valid for us but we can't determine that via react-dates API
    // Adding an observer seems to be the only consistent way to check for emptiness 😮‍💨
    // Maybe this should just be a native input[type=date]?
    const observer = new MutationObserver(() => {
      if (!input.value) setDateInvalid(false);
    });
    observer.observe(input, {
      attributeFilter: ['value'],
      attributes: true
    });
    return () => observer.disconnect();
    // Include the container ref just so this effect triggers after render.
  }, [setDateInvalid, containerRef]);
  (0, _react.useEffect)(() => {
    const handleEscape = _ref2 => {
      let {
        key
      } = _ref2;
      if (key === 'Escape') setCalendarFocused(false);
    };
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);
  const handleDateChange = newDate => {
    // if the date entered is not a valid date, date will be null
    setDateInvalid(!(0, _moment.default)(newDate).isValid());
    onDateChange(newDate);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.DatePicker, {
    className: dateInvalid ? 'invalid' : '',
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_calendar.SingleDatePicker, {
    ariaLabel: intl.formatMessage(_messages.default.ariaJumpToDateCalendarInput),
    date: date || null,
    displayFormat: MOMENT_FORMAT,
    focused: calendarFocused,
    hideKeyboardShortcutsPanel: true,
    id: INPUT_ID,
    inputIconPosition: "before",
    numberOfMonths: 1,
    onDateChange: handleDateChange,
    onFocusChange: _ref3 => {
      let {
        focused
      } = _ref3;
      return setCalendarFocused(focused);
    },
    placeholder: MOMENT_FORMAT,
    required: false,
    screenReaderInputMessage: dateInvalid ? intl.formatMessage(_messages.default.jumpToDateInvalidDateError) : intl.formatMessage(_messages.default.ariaJumpToDateInputDescription),
    showClearDate: true,
    showDefaultInputIcon: true,
    small: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    // react-dates includes a hidden aria-describedby, so hide this to screen readers
    "aria-hidden": "true",
    role: "presentation",
    className: "dateInvalidMessage"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.jumpToDateInvalidDateError)));
};
BaseJumpToDate.defaultProps = {
  date: null
};
BaseJumpToDate.propTypes = {
  date: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),
  dateInvalid: _propTypes.bool.isRequired,
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  }),
  onDateChange: _propTypes.func.isRequired,
  setDateInvalid: _propTypes.func.isRequired
};
const JumpToDate = exports.JumpToDate = (0, _intl.injectIntl)(BaseJumpToDate);
BaseJumpToDate.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BaseJumpToDate",
  "props": {
    "date": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "dateInvalid": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    },
    "onDateChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "setDateInvalid": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};